import Cookies from "js-cookie";

import { OverlaysService } from "./overlays.service";
import { USEREMAIL, SITEURL } from "@libTs/cms.globals";

export interface ICompareListItem {
    ItemCode: string;
    ItemName: string;
    ImageURL: string;
    Group: string;
}

export class CompareService {
    private get EXPIRES(): Date {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 20);
        return now;
    }
    private readonly COOKIENAME = "compare" + USEREMAIL;
    private readonly COOKIESETTINGS = { path: "/", expires: this.EXPIRES };

    private overlaysSvc: OverlaysService;

    public list: any[] = [];

    public isLoggedIn = false;

    public openComparelist = false;

    constructor(overlaysSvc: OverlaysService, isLoggedIn: boolean = false) {
        this.overlaysSvc = overlaysSvc;
        this.isLoggedIn = isLoggedIn;

        this.initializeListFromCookie();
    }

    public isUserLoggedIn(): boolean {
        return this.isLoggedIn;
    }

    public initializeListFromCookie(): void {
        const cookie = Cookies.get(this.COOKIENAME);
        if (typeof cookie === "string" && cookie.length > 0) {
            try {
                const data = JSON.parse(cookie);
                if (Array.isArray(data)) {
                    this.list = data;
                }
            } catch (e) {
                console.error("Error parsing cart cookie", e);
            }
        }
    }

    // add to compare list
    public add(item: ICompareListItem): void {
        if (this.isUserLoggedIn()) {
            if (!this.isInList(item)) {
                this.list.push(item);
                this.saveListToCookie();
            }
            this.openComparelist = true;
        }
    }

    private isInList(item: ICompareListItem): boolean {
        return this.list.some(
            (listItem) => listItem.ItemCode === item.ItemCode,
        );
    }

    private saveListToCookie(): void {
        Cookies.set(
            this.COOKIENAME,
            JSON.stringify(this.list),
            this.COOKIESETTINGS,
        );
    }

    // remove from compare list
    public remove(item: ICompareListItem): void {
        if (this.isUserLoggedIn()) {
            this.list = this.list.filter(
                (listItem) => listItem.ItemCode !== item.ItemCode,
            );
            this.saveListToCookie();
        }
    }

    public removeGroup(group: string): void {
        if (this.isUserLoggedIn()) {
            this.list = this.list.filter(
                (listItem) => listItem.Group !== group,
            );
            this.saveListToCookie();
        }
    }
}
